require('../../modules/es6.symbol');
module.exports = require('../../modules/_core').Symbol['for'];
